import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { marketplaceKeys } from '@/lib/task-query-keys';
import { toDisplayRates, type DisplayRate, type RateBulletin } from '@/lib/rate-mapping';
import { getRates } from './api';

/**
 * Kur bulteni sorgusu.
 *
 * ANKET ARALIGI 60 SANIYE. Mobil 10 saniyede bir soruyordu ve o dogrudan
 * TCMB'ye gidiyordu; biz KENDI gecidimize soruyoruz ve gecit zaten 60 saniye
 * onbellekliyor. Daha sik sormak ayni yaniti tekrar tekrar almak, yani kendi
 * altyapimizi bosuna yormak olurdu. TCMB bulteni gunde bir kez yayinlaniyor.
 */
const REFETCH_INTERVAL_MS = 60_000;

export type UseRatesResult = {
  rows: DisplayRate[];
  bulletin: RateBulletin | undefined;
  isLoading: boolean;
  isError: boolean;
  refetch: () => void;
};

export const useRates = (): UseRatesResult => {
  const query = useQuery({
    queryKey: marketplaceKeys.rates(),
    queryFn: getRates,
    refetchInterval: REFETCH_INTERVAL_MS,
    // Bulten 60 sn'de bir tazeleniyor; daha kisa bir bayatlik suresi her
    // bilesen baglanmasinda gereksiz bir istek uretirdi.
    staleTime: REFETCH_INTERVAL_MS,
  });

  const data = query.data;
  const rows = useMemo(() => (data ? toDisplayRates(data) : []), [data]);

  return {
    rows,
    bulletin: data,
    isLoading: query.isPending,
    isError: query.isError,
    refetch: () => {
      void query.refetch();
    },
  };
};
